import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'
import type { PointsAwardedEvent } from '../../../shared/domain/gamification/types.no-deps'

export const route: Route = { method: 'POST', pattern: '/api/gamification/awardPoints' }

type Params = never
type Body = { pointsAwardedEvents: PointsAwardedEvent[] }
type Query = never
type Output = { totalPoints: number }

export type AwardPointsEndpoint = Endpoint<Params, Body, Query, Output>

export const awardPointsRequest = (request: Request, args: RequestArgs<AwardPointsEndpoint>) =>
    request<AwardPointsEndpoint>(route, args)
